export default __webpack_public_path__ + "f7e222500758e703df460bf76bd5f407.jpg";